import React from "react";
import axios from "axios";
import "./style.css";
import HeaderEn from "../../header-en";
import FooterEn from "../../footer-en";

class ProductsEn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sendMessage: "Hello,I'mInProductsPageEn",
    };
  }

  componentDidMount = () => {
    this.handleRedirect();
  };

  //put this function in the related component in componentDidMount
  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
  }

  render() {
    return (
      <div>
        <HeaderEn />
        <div className="about-profile-body d-ltr d-flex justify-content-center align-items-center w-100 h-90vh">
          <a href="/en/products/autism-screening-ticket">
            {"Click for Autism Screening Form"}
          </a>
        </div>
        <FooterEn />
      </div>
    );
  }
}

export default ProductsEn;
